import { Injectable } from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import { Observable } from 'rxjs';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  constructor(private http: HttpClient) { }

  // GET: Fetch all categories from MySQL
  getCategories(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/categories`);
  }
  // GET: Fetch all categories from MySQL


  // POST: Send new category to NestJS
  createCategory(categoryData: any): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/categories`, categoryData);
  }
  createSubCategory(categoryData: any): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/categories/sub`, categoryData);
  }

  // DELETE: Remove category by ID
  deleteCategory(id: number): Observable<any> {
    return this.http.delete(`${environment.apiUrl}/categories/${id}`);
  }
  deleteSubCategory(id: number): Observable<any> {
    return this.http.delete(`${environment.apiUrl}/categories/sub/${id}`);
  }
  login(username:string, password:string):Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/auth/login`, {username, password});
  }

  createProduct(payload: any): Observable<any> {
    return this.http.post(`${environment.apiUrl}/products`, payload);
  }

  getProducts(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/products`);
  }

  getMaterials(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/materials`);
  }

  createMaterial(payload: any): Observable<any> {
    return this.http.post(`${environment.apiUrl}/materials`, payload);
  }

  updateMaterial(id: number, payload: any): Observable<any> {
    return this.http.put(`${environment.apiUrl}/materials/${id}`, payload);
  }

  deleteMaterial(id: number): Observable<any> {
    return this.http.delete(`${environment.apiUrl}/materials/${id}`);
  }

  getProductById(id: any): Observable<any> {
    return this.http.get(`${environment.apiUrl}/products/${id}`);
  }
  getProductByCategoryId(id: any): Observable<any> {
    return this.http.get(`${environment.apiUrl}/products/category/${id}`);
  }
  getProductBySubCategoryId(id: any): Observable<any> {
    return this.http.get(`${environment.apiUrl}/products/subcategory/${id}`);
  }
  createOrder(payload: any): Observable<any> {
    return this.http.post(`${environment.apiUrl}/orders`, payload);
  }
  getAllOrders(): any {
    return this.http.get<any>(`${environment.apiUrl}/orders`);
  }
  orderStatus(status:string): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/orders/status/${status}`);
  }
  changeStatus(confOrdId:string, status:any): Observable<any> {
    return this.http.patch(`${environment.apiUrl}/orders/${confOrdId}/status`, status);
  }
  getOrdersByOrderConfigId(orderConfigId: string): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/orders/track/${orderConfigId}`);
  }
  deleteProductById(id:number): Observable<any> {
    return this.http.delete(`${environment.apiUrl}/products/${id}`);
  }
  editProduct(payload: any, productId:number): Observable<any> {
    return this.http.patch(`${environment.apiUrl}/products/${payload.id}`, payload);
  }
}
